import { Sequence, useCurrentFrame } from 'remotion';
import { useMemo } from 'react';

// Types
import { FeedbackData } from '../types';

// Components
import { FeedbackCard } from './FeedbackCard';

// Utils
import { getVisibleFeedbacks } from '../utils';

export interface MainContentProps {
  feedbacks?: FeedbackData[];
  /** Delay in frames before animations start (for transition overlap) */
  animationDelay?: number;
}

export const MainContent = ({
  feedbacks = [],
  animationDelay = 0,
}: MainContentProps) => {
  const rawFrame = useCurrentFrame();
  // Apply animation delay
  const frame = Math.max(0, rawFrame - animationDelay);

  // Visible feedbacks at current frame
  const visibleFeedbacks = useMemo(
    () =>
      getVisibleFeedbacks({
        feedbacks,
        currentFrame: frame,
        animationDelay,
      }),
    [feedbacks, frame, animationDelay],
  );

  return (
    <Sequence name="Main Content" className="flex-center">
      {visibleFeedbacks.map(
        ({
          feedback,
          index,
          isVisible,
          startFrame,
          transitionStartFrame,
          variant,
        }) =>
          isVisible && (
            <FeedbackCard
              key={`feedback-${index}`}
              {...feedback}
              variant={variant}
              startFrame={startFrame}
              transitionStartFrame={transitionStartFrame}
            />
          ),
      )}
    </Sequence>
  );
};
